export default "<div class=\"settings\" >\n  <app-landing-profile></app-landing-profile>\n</div>";